import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Constant } from 'app/config/constants';
import { of } from 'rxjs/internal/observable/of';
import { Common } from 'app/model/entity/common';

export interface SessionCheckResponse {
  hasConcurrentSameUsers: boolean;
  hasConcurrentDifferentUsers: boolean;
}

export interface SessionCreateResponse {
  sessionId: number;
  email: string;
  status: string;
}

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private readonly sessionUrl = Constant.BACKEND_URL + Constant.UAA_SERVICE_URL + 'api/sessions';
  commonObject: Common;

  constructor(private http: HttpClient) {}

  /**
   * Check for concurrent logins and display modal if detected
   */
  checkConcurrentSessions(): Observable<SessionCheckResponse> {
    return this.http.get<SessionCheckResponse>(`${this.sessionUrl}/check-concurrent`).pipe(
      catchError(error => {
        console.error('Error checking concurrent sessions:', error);
        return of({ hasConcurrentSameUsers: false, hasConcurrentDifferentUsers: false });
      })
    );
  }

  /**
   * Create a new user session
   */
  createSession(): Observable<SessionCreateResponse> {
    return this.http.post<SessionCreateResponse>(`${this.sessionUrl}/create`, {}).pipe(
      catchError(error => {
        console.error('Error creating session:', error);
        return of({
          sessionId: '',
          email: '',
          status: 'error',
          message: error.message || 'Error creating session'
        } as any);
      })
    );
  }

  /**
   * deactivateSessionById
   * @param sessionId
   * @returns
   */
  deactivateSessionById(): Observable<any> {
    let sessionUrl = Constant.BACKEND_URL + Constant.UAA_SERVICE_URL + 'api/sessions';
    return this.http.get(`${sessionUrl}/deactivate-by-id`).pipe(
      catchError(error => {
        return of({ success: false, message: error.message || 'Error deactivating session' });
      })
    );
  }
}
